import { CreateReviewPayload } from "@/interfaces/review";
import request from "@/utils/request";

const createReview = async (payload: CreateReviewPayload) =>
  request({
    method: "POST",
    url: "review",
    params: {},
    data: payload,
  }).then((response) => response);

export { createReview };
